import React from 'react';
// import ProductType from './ProductType';
import ProductTypeBox from './ProductTypeBox';
import { Link } from 'react-router-dom';
import categories from '../../../objects/categories';

import './our-products.scss';

/**
 * OurProducts Component
 * Shows the types of products available and a quick description about these types
 * It also provides a "Browser Products" button redirecting user to Products page
 */
const OurProducts = props => {
   const historical = [
      categories.novelsChildren, 
      categories.fictionChildren,
      categories.historicalFictionChildren,
      categories.historicalFictionTeens,
      categories.fictionTeens
   ]

   const theology = [
      categories.bibleConfessions,
      categories.liturgyChurchOrder,
      categories.reformedDoctrine,
      categories.pastoralCare,
      categories.christianLife,
      categories.covenantFamily,
      categories.churchHistory,
      categories.politicalSocial
   ]

   const media = [
      categories.audioBooks,
      categories.musicPsalms,
      categories.music,
      categories.dvd
   ]

   return (
      <div className="container-fluid our-products">
         <div className="row justify-content-center our-products-heading">
            <h2>Our Products</h2>
         </div>

         {/* <div className="row justify-content-center our-products-types">
            <ProductType label="Books" image={1}></ProductType>
            <ProductType label="Sheet Music" image={2}></ProductType>
            <ProductType label="Ebooks" image={3}></ProductType>
            <ProductType label="CD / DVD" image={4}></ProductType>
         </div> */}

         <div className="our-products-margin"></div>
         <ProductTypeBox title="Historical fiction & novel" categories={historical} setFilter={props.setFilter} updateLastProductPage={props.updateLastProductPage}/>
         <ProductTypeBox title="Theology" categories={theology} setFilter={props.setFilter} updateLastProductPage={props.updateLastProductPage}/>
         <ProductTypeBox title="Media" categories={media} setFilter={props.setFilter} updateLastProductPage={props.updateLastProductPage}/>

         <div className="row justify-content-center">
            <Link to="/products" className="browse-button">Browse Products</Link>
         </div>
      </div>
   )
}

export default OurProducts;